import { EVENTS } from '../../bus/events.const';
import { WIRES } from '../wires';
import { Wiring } from '../wiring.interfaces';

export const SEARCH_WIRING: Wiring = {
  [EVENTS.Search]: [
    WIRES.scrollToTop,
    WIRES.clearPage,
    WIRES.dispatchSearch,
    WIRES.pushURL
  ],
  [EVENTS.ClearFacetsFilters]: [
    WIRES.clearFacetsFilters,
    WIRES.search,
    WIRES.resetNextQueryResults,
    WIRES.trackClearFilters
  ],
  [EVENTS.InputQueryChanged]: [
    WIRES.openEmpathize,
    WIRES.queryOriginDefault,
    WIRES.storeInputQuery,
    WIRES.setInputAsDirty,
    WIRES.emitDebouncedQueryChangedEvent,
    WIRES.getTermSuggestions,
    WIRES.getIdentifierSuggestions
  ],
  [EVENTS.ClearInputQuery]: [
    WIRES.clearInputQuery,
    WIRES.emitQueryCleared
  ],
  [EVENTS.QueryChanged]: [
    WIRES.changeQuery
  ],
  [EVENTS.QuerySet]: [
    WIRES.emitNewQueryIfItIsNew,
    WIRES.clearFiltersIfNewQueryAndOldQueryExisted,
    WIRES.deselectRelatedTags,
    WIRES.storeQuery,
    WIRES.storeInputQuery,
    WIRES.search
  ],
  [EVENTS.NewQuerySet]: [], // This Event is maintained to guarantee backwards compatibility
  [EVENTS.QueryCleared]: [
    WIRES.clearSearch,
    WIRES.clearTermSuggestions,
    WIRES.clearRelatedTags,
    WIRES.pushURL,
    WIRES.setUserAcceptedQuery
  ],
  [EVENTS.RetrySearch]: [
    WIRES.clearFilters,
    WIRES.search
  ],
  [EVENTS.SearchSuccess]: [
    WIRES.disableResultsEnd,
    WIRES.storeSearchState,
    WIRES.setRemainingFacets,
    WIRES.clearFallbackFiltersResults,
    WIRES.loadNextQueriesResultsIfEnabled,
    WIRES.redirectIfDirect,
    WIRES.trackQuery,
    WIRES.emitSearchResponseType,
    WIRES.applyScrollIfNeeded
  ],
  [EVENTS.SearchSuccessWithResults]: [
    WIRES.addTermToHistories
  ],
  [EVENTS.SearchSuccessWithPartialResults]: [],
  [EVENTS.SearchSuccessWithoutResults]: [
    WIRES.getNoResultsRecommendationsIfNotPresent
  ],
  [EVENTS.FilterClicked]: [
    WIRES.emitFilterSelectedType
  ],
  [EVENTS.FilterSelected]: [
    WIRES.toggleFilter,
    WIRES.syncPreselectedFiltersWithCompulsories,
    WIRES.search,
    WIRES.resetNextQueryResults,
    WIRES.trackFilter
  ],
  [EVENTS.FilterSelectedNotAvailable]: [],
  [EVENTS.Redirection]: [
    WIRES.trackPendingQuery,
    WIRES.redirection
  ],
  [EVENTS.ColumnNumberChanged]: [
    WIRES.changeColumnNumber,
    WIRES.trackColumnsChange
  ],
  [EVENTS.ViewPartialResult]: [
    WIRES.queryOriginPartial,
    WIRES.loadPartialResult,
    WIRES.scrollToTop,
    WIRES.emitUserAcceptedQuery
  ],
  [EVENTS.SetFacetCollapse]: [
    WIRES.setFacetCollapse
  ],
  [EVENTS.AutoCompleteSuggestionSelected]: [
    WIRES.queryOriginTopTerm,
    WIRES.changeQuery,
    WIRES.emitDebouncedQueryChangedEvent,
    WIRES.getTermSuggestions,
    WIRES.getIdentifierSuggestions,
    WIRES.blurSearchInput
  ],
  [EVENTS.FilterValueChanged]: [
    WIRES.updateFilterValue
  ],
  [EVENTS.DynamicFilterSelected]: [
    WIRES.selectFilter,
    WIRES.search
  ],
  [EVENTS.DynamicFilterCleared]: [
    WIRES.deselectFilter,
    WIRES.search
  ],
  [EVENTS.UserAcceptedQueryChanged]: [
    WIRES.setUserAcceptedQuery,
    WIRES.closeEmpathize,
    WIRES.getRelatedTags,
    WIRES.getNextQueries
  ],
  [EVENTS.UpdateResult]: [
    WIRES.updateResult
  ]
};
